import { useEffect, useMemo, useState } from 'react';
import {
  useEntityList,
  useStarredEntities,
} from '@backstage/plugin-catalog-react';
import { DEFAULT_NAMESPACE, Entity } from '@backstage/catalog-model';
import { useLocation } from 'react-router-dom';
import { CustomEntityFilters } from '../utils';

export const useEntities = () => {
  const {
    backendEntities: entities,
    loading,
    error,
    filters: appliedFilters,
    updateFilters,
    queryParameters,
    pageInfo,
    totalItems = 0,
    limit,
    offset,
    setLimit,
    setOffset,
    paginationMode,
  } = useEntityList<CustomEntityFilters>();

  const location = useLocation();
  const { pathname } = location;
  const { starredEntities } = useStarredEntities();
  const [formattedItems, setFormattedItems] = useState<any[]>([]);

  useEffect(() => {
    const setProcessedEntities = () => {
      const processedEntities = entities?.map((item: Entity) => {
        return {
          kind: item.kind,
          namespace: item.metadata.namespace ?? 'default',
          name: item.metadata.name,
          title: item.metadata.title ?? item?.metadata.name,
          description: item?.metadata.description ?? '',
          tags: item.metadata.tags ?? [],
          owner: item.spec?.owner ?? '',
          targets: item.spec?.targets ?? '',
          type: item.spec?.type ?? '',
          uri: `/catalog/${item.metadata.namespace ?? DEFAULT_NAMESPACE}/${item.kind}/${item.metadata.name}`,
        };
      });

      setFormattedItems(processedEntities);
    };

    if (pathname === '/catalog/favourites' && starredEntities.size === 0) {
      setFormattedItems([]);
    } else {
      setProcessedEntities();
    }
  }, [entities, pathname, starredEntities, setFormattedItems]);

  return useMemo(
    () => ({
      entities,
      loading,
      error,
      appliedFilters,
      updateFilters,
      queryParameters,
      pageInfo,
      totalItems: formattedItems?.length > 0 ? totalItems : 0,
      limit,
      offset,
      paginationMode,
      formattedItems,
      starredEntities,
      setLimit,
      setOffset,
    }),
    [
      entities,
      formattedItems,
      loading,
      error,
      appliedFilters,
      updateFilters,
      queryParameters,
      pageInfo,
      totalItems,
      limit,
      offset,
      paginationMode,
      starredEntities,
      setLimit,
      setOffset,
    ],
  );
};
